import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class TimeSheetDiaryService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves page get for time sheet diary.
     *
     * @datatask 1300
     * @datataskName sp_ws_p2_w_timesheetdiary_get
     * @param params
     * @returns promise containing page get.
     */
    public async getTimeSheetDiary(params: GetTimeSheetDiaryParams): Promise<TimeSheetDiaryGet> {
        return (await this.datatask.Post(1300, params))[0];
    }

    /**
     * Retrieves list of portal users for the time sheet diary.
     *
     * @datatask 1301
     * @datataskName sp_ws_p2_w_timesheetdiary_portal_user_list
     * @param params
     * @returns promise containing list of protal users..
     */
    public async getPortalUsers(params: GetTimeSheetDiaryParams): Promise<TSDPortalUserItem[]> {
        return this.datatask.Post(1301, params);
    }

    /**
     * Retrieves list of tasks.
     *
     * @datatask 1302
     * @datataskName sp_ws_p2_w_timesheetdiary_task_list
     * @param params
     * @returns promise containing list of tasks
     */
    public async getTasks(params: TimeSheetDiaryGet): Promise<TSDTaskItem[]> {
        return this.datatask.Post(1302, params);
    }

    /**
     * Retrieves list of owners.
     *
     * @datatask 1303
     * @datataskName sp_ws_p2_w_timesheetdiary_owner_list
     * @param params
     * @returns promise containing list of owners
     */
    public async getOwners(params: TimeSheetDiaryGet): Promise<TSDOwnerItem[]> {
        return this.datatask.Post(1303, params);
    }

    /**
     * Updates the given powtime with new start and end times.
     *
     * @datatask 2317
     * @datataskName sp_ws_p2_w_timesheetdiary_update
     * @param params
     * @returns promise containing errors if any.
     */
    public async updateTask(params: UpdateTaskParams): Promise<{ '@error_code': string; '@error_message': string }> {
        return (await this.datatask.Post(2317, params))[0];
    }
}

export interface UpdateTaskParams {
    id: string;
    start: string;
    end: string;
}

export interface GetTimeSheetDiaryParams {
    argtype: string;
    argvalue: string;
}

export interface TimeSheetDiaryGet {
    date_fom: string;
    portal_user_keyno: string;
    selectedview: string;
    item_state_new: string;
    item_parms_new: string;
    argtype: string;
    argvalue: string;
    page_heading: string;
    show_setting: '1' | '0';
}

/**
 * Time-Sheet-Diary portal user item.
 */
export interface TSDPortalUserItem {
    item_id: string;
    item_name: string;
    orderby: string;
}

export interface TSDTaskItem {
    item_id: string;
    item_name: string;
    item_state: string;
    item_parms: string;
    item_path: string;
    orderby: string;
    start_dt: string;
    end_dt: string;
    portal_user_keyno: string;
    description: string;
}

export interface TSDOwnerItem {
    color: string;
    orderby: string;
    portal_user_keyno: string;
    portal_user_name: string;
}
